import { render, staticRenderFns } from "./youtubeVideo.vue?vue&type=template&id=5d9cf4b5&scoped=true"
import script from "./youtubeVideo.vue?vue&type=script&lang=js"
export * from "./youtubeVideo.vue?vue&type=script&lang=js"
import style0 from "./youtubeVideo.vue?vue&type=style&index=0&id=5d9cf4b5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9cf4b5",
  null
  
)

export default component.exports